import { loadScript } from './utils';

export default function selectUI() {
	loadScript('selectScript', window.selectScript, function() {
		return new Promise((resolve, reject) => {
			initSelect();

			resolve();
		})
	})
}

const initSelect = () => {
	$('.js-custom-select select').niceSelect();
}
